"use client"

import ProductColorButtonSkeleton from "@/components/common/ProductColorButton/index.skeleton"
import ProductLabelSkeleton from "@/components/common/ProductLabel/index.skeleton"
import { Col, Row, Skeleton } from "antd"

const ProductColorsSkeleton = () => {

  return (
    <>
      <Row>
        <ProductLabelSkeleton />
      </Row>
      <Row gutter={[10, 10]}>
        {Array(7).fill(null).map((_, idx) => {
          return (
            <Col key={idx}>
              <ProductColorButtonSkeleton />
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductColorsSkeleton